import { render } from "./SongSection.vue?vue&type=template&id=25a9e57c"
import script from "./SongSection.vue?vue&type=script&lang=js"
export * from "./SongSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__